import {Preloader} from './Preloader';
import {Popup} from "./Popup";
import {Toggle} from "./Toggle";
import {UrlHashNavigation} from "./UrlHashNavigation";
import {FixedHeader} from "./FixedHeader";
import {MotionOnScroll} from "./MotionOnScroll";
import {Anchor} from "./Anchor";
import {CookiesWarning} from "./CookiesWarning";
import {ScrollBox} from "./Scrollbox";
import {Responsive} from "./Responsive";
import {Scroll} from "./Scroll";
import {ProgressBar} from "./ProgressBar";
import {SearchContainer} from "./SearchContainer";
import {SidebarFixator} from "./SidebarFixator";
import {CommentForm} from "./CommentForm";
import {Post} from "./Post";
import {Providers} from "./Providers";
import {Profile} from "./Profile";
import {Alert} from "./Alert";
import {LazyLoading} from "./LazyLoading";
import {Dropdown} from "./Dropdown";
import {Splide} from '@splidejs/splide';
import {URLHash} from '@splidejs/splide-extension-url-hash';

require('smoothscroll-for-websites');

document.addEventListener( 'DOMContentLoaded',  () => {
    const theme = window.theme;

    // Initializing the preloader
    const preloader = new Preloader ({
        element: `.preloader`,
        timeout: 400
    }).init();

    // Creating pop-up windows
    const sidePanel = new Popup ({
        window: `.side-panel__layout`,
        overlay: `#side-overlay`
    });
    sidePanel.addTriggers(`.menu-button, .side-panel__close, #side-overlay`);

    const loginPopup = new Popup ({
        window: `.login-popup`,
        overlay: `#login-overlay`
    });
    loginPopup.addTriggers(`.login-link, .login-close, #login-overlay`);

    // Adding toggles
    const nav = document.querySelectorAll(`.timeline__item`);
    nav.forEach(it => {
        new Toggle({
            triggers: it.querySelectorAll(`.timeline__toggle`),
            target: it.querySelector(`.timeline__group`)
        });
    });

    // Adding modals
    const modals = [`.phone-one`, `.breadcrumbs`];
    modals.forEach(selector => {
        const modals = document.querySelectorAll(selector);
        modals.forEach(modal => {
            new Dropdown({
                dropdown: modal.querySelector(`${selector}__dropdown`),
                trigger: modal.querySelector(`${selector}__button`),
                container: document.body
            })
        });
    });

    // Initializing responsive menu
    const categories = new Responsive ({
        container: document.querySelector(`.categories__grid`),
        list: document.querySelector(`.categories__list`),
        dropdown: document.querySelector(`.dropdown__list`),
        trigger: document.querySelector(`.dropdown__btn`)
    });

    // Fixing header
    const fixed = document.querySelector(`.menu-button`) as HTMLElement;
    if (theme.settings.fixedHeader) new FixedHeader({element: fixed});

    // Anchors
    const anchors = document.querySelectorAll(`.is-anchor`);
    anchors.forEach(element => new Anchor({element: element as HTMLElement}));

    // Cookies warning
    new CookiesWarning({
        popup: document.querySelector(`.js-cookies`),
        trigger: document.querySelector(`.js-cookies-button`),
        cookie: `cookies`,
        animation: `fadeOut`,
        timeout: 1000
    });

    // Auth
    const providers = document.querySelectorAll(`.profile-adapter`) as NodeListOf<HTMLElement>;
    new Providers(providers);

    const
        profileInfo = document.querySelector(`.user-info__wrapper`),
        profileForm = document.querySelector(`.profile__form`);
    if (profileInfo && profileForm) {
        const profile = new Profile({
            infoWrapper: profileInfo as HTMLElement,
            formWrapper: profileForm as HTMLElement,
            editButton: profileInfo.querySelector(`[type=button]`),
            cancelButton: profileForm.querySelector(`[type=button]`),
            passwordFields: profileForm.querySelector(`.wa-field-password`),
            userpic: profileForm.querySelector(`.wa-field-photo`)
        });
    }

    new Alert(document.querySelectorAll(`.auth__message`));

    //Initing comment form
    const
        formWrapper = document.getElementById(`b-comment-form`),
        commentsWrapper =  document.querySelector(`.comments__wrapper`) as HTMLElement;
    if (formWrapper && commentsWrapper) {
        const cf = new CommentForm({
            formWrapper,
            commentsWrapper,
            form: formWrapper.querySelector(`.comment-form form`),
            guestAuth: formWrapper.querySelector(`[data-provider=guest-auth]`),
            providers: formWrapper.querySelector(`.providers`),
            textarea: formWrapper.querySelector(`textarea`),
            post: formWrapper.previousElementSibling as HTMLElement,
            spinner: formWrapper.querySelector(`.icon-spin`)
        });
    }

    // Adding motion on scroll
    const mos = [`.mainscreen`];
    for (let i = 0; i < mos.length; i++) {
        const blocks = document.querySelectorAll(mos[i]);
        blocks.forEach(block => new MotionOnScroll(block as HTMLElement));
    }

    new ProgressBar(document.getElementById(`post-progress-bar`));

    // Scroll
    const scrollTopButton = new Scroll({
        trigger: document.querySelector(`.scroll-top`),
        to: 0
    });

    // Search container
    new SearchContainer({
        input: document.querySelector(`.search__input`),
        container: document.querySelector(`.header__search`)
    });

    const posts = document.querySelectorAll(`.post`);
    posts.forEach(post => new Post(post));

    // Lazy loading
    const lazyloading = document.querySelector(`.stream__wrapper`) as HTMLElement;
    if (lazyloading && lazyloading.hasAttribute(`data-lazyloading`)) {
        new LazyLoading({
            names: {
                list: `stream__list`,
                items: `stream__item`,
                paging: `paging__wrapper`
            },
            wrapper: lazyloading
        });
    }

    // Sliders
    const carousel = document.querySelectorAll(`.carousel__splide`);
    carousel.forEach(element => {
        const carousel = new Splide( element as HTMLElement, {
            type: 'loop',
            pagination: false,
            breakpoints: {
                '768': {
                    perPage: 1,
                    gap: '1rem',
                },
                '1100': {
                    perPage: 2,
                    gap: '1rem',
                },
            },
            perPage: 3,
            gap: '2rem',
            perMove: 1,
            drag: 'free',
            slideFocus: false,
            classes: {
                arrows: 'splide__arrows carousel__arrows',
                arrow : 'splide__arrow carousel__arrow',
                prev  : 'splide__arrow--prev carousel__arrow--prev',
                next  : 'splide__arrow--next carousel__arrow--next',
            },
        }).mount();
    });

    const sliders = document.querySelectorAll(`.slider__splide`);
    sliders.forEach(element => {
        const autoplay = !!element.getAttribute(`data-autoplay`);
        const slider = new Splide( element as HTMLElement, {
            type  : 'fade',
            rewind: true,
            drag: false,
            arrows : false,
            pagination : false,
            speed: 200,
            slideFocus: false,
            autoplay: autoplay,
            pauseOnHover: false,
            pauseOnFocus: false,
        }).mount({URLHash} );
    });

    const latestPosts = document.querySelectorAll(`.sidebar-latest-posts`);
    latestPosts.forEach(element => {
        const autoplay = !!element.getAttribute(`data-autoplay`);
        const latestPost = new Splide( element as HTMLElement, {
            type  : 'fade',
            rewind: true,
            arrows : false,
            pagination: false,
            slideFocus: false,
            speed: 200,
            autoplay: autoplay,
            pauseOnHover: false,
            pauseOnFocus: false,
        }).mount();
    });

    const photos = document.querySelectorAll(`.photos`);
    photos.forEach(element => {
        const photo = new Splide( element as HTMLElement, {
            type  : 'fade',
            rewind: true,
            pagination: false,
            slideFocus: false,
            speed: 200,
            classes: {
                arrows: 'splide__arrows photos__arrows',
                arrow : 'splide__arrow photos__arrow',
                prev  : 'splide__arrow--prev photos__arrow--prev',
                next  : 'splide__arrow--next photos__arrow--next',
            },
        }).mount();
    });

    // URL hash navigation
    const navigation = document.querySelectorAll(`.slider__nav-list`);
    navigation.forEach(element => {
        new UrlHashNavigation(element);
    });

    // Scrollbox
    const scrollbox = document.querySelectorAll('.scrollbox');
    for (let element of scrollbox) {
        new ScrollBox({
            viewport: element.querySelector('.scrollbox__viewport'),
            content: element.querySelector('.scrollbox__content-box')
        });
    }

});

window.onload = function() {
    new SidebarFixator({
        sidebar: document.querySelector(`.sidebar__buttons`),
        footer: document.querySelector(`.post-page__footer`)
    });
};